export const SET_LISTING_DATA = "SET_LISTING_DATA";
export const RESET_SPEC_ERRORS ="RESET_SPEC_ERRORS"
export const SET_SESSION = "SET_SESSION";
export const UPDATE_PRODUCT_PRICE = 'UPDATE_PRODUCT_PRICE';
export const UPDATE_PRODUCT_SELLING_PRICE = 'UPDATE_PRODUCT_SELLING_PRICE';
export const DELETE_PRODUCT = 'DELETE_PRODUCT';
export const SET_ACTION_CARD_DATA = 'SET_ACTION_CARD_DATA';
export const SET_SEARCH_DATA = 'SET_SEARCH_DATA';
export const HIDE_PRODUCT_EDIT_SLIDER = 'HIDE_PRODUCT_EDIT_SLIDER';
export const HIDE_ITEM_SEARCH_SLIDER = 'HIDE_ITEM_SEARCH_SLIDER';
export const SHOW_ITEM_SEARCH_SLIDER = 'SHOW_ITEM_SEARCH_SLIDER';
export const SHOW_NOT_FOUND_MODAL = 'SHOW_NOT_FOUND_MODAL';
export const HIDE_NOT_FOUND_MODAL = 'HIDE_NOT_FOUND_MODAL';
export const SHOW_PRODUCT_EDIT_SLIDER = 'SHOW_PRODUCT_EDIT_SLIDER';
export const EDIT_PRODUCT = "EDIT_PRODUCT";
export const EDIT_ENRICH_PRODUCT = "EDIT_ENRICH_PRODUCT";
export const UPDATE_EDIT_PRODUCT_DETAIL = "UPDATE_EDIT_PRODUCT_DETAIL";
export const UPDATE_PRODUCT_IMAGE = 'UPDATE_PRODUCT_IMAGE';
export const EMPTY_SEARCH_DATA = 'EMPTY_SEARCH_DATA';
export const TOGGLE_EDIT_IMAGE_OPTIONS = 'TOGGLE_EDIT_IMAGE_OPTIONS';
export const DELETE_PRODUCT_IMAGE = 'DELETE_PRODUCT_IMAGE';
export const SET_UOM_DATA = 'SET_UOM_DATA';
export const SET_CURRENT_EDIT_PAGE = 'SET_CURRENT_EDIT_PAGE';
export const SHOW_TOAST_MESSAGE_LOCAL = 'SHOW_TOAST_MESSAGE_LOCAL';
export const HIDE_TOAST_MESSAGE_LOCAL = 'HIDE_TOAST_MESSAGE_LOCAL';
export const PRODUCTSCORE = 'PRODUCTSCORE';
export const PRODUCT_UNDER_EDIT = 'PRODUCT_UNDER_EDIT';
export const SAVE_ADD_EDIT_PRODUCT = 'SAVE_ADD_EDIT_PRODUCT';
export const SAVE_REJECTED_VIA_AUDIT = 'SAVE_REJECTED_VIA_AUDIT'
export const DISCARD_ADD_PRODUCT_MEDIA = 'DISCARD_ADD_PRODUCT_MEDIA';
export const RESET_PRODUCT_DATA = 'RESET_PRODUCT_DATA';
export const INIT_ADD_PRODUCT = 'INIT_ADD_PRODUCT';
export const IS_PRODUCT_UPDATED = 'IS_PRODUCT_UPDATED';
export const GET_BIZ = 'GET_BIZ';
export const SETPSVINFODATA = 'SETPSVINFODATA';
export const UPDATE_BIZ = 'UPDATE_BIZ';
export const TOGGLE_BIZ = 'TOGGLE_BIZ';
export const SET_CONTRACT_DATA = 'SET_CONTRACT_DATA';
export const SET_LOGGED_USER = 'SET_LOGGED_USER';
export const SET_OBE_LOGGED_USER = 'SET_OBE_LOGGED_USER';
export const SET_APP_CAT_COV_USER = 'SET_APP_CAT_COV_USER';
export const SET_APPROVAL_PENDING = 'SET_APPROVAL_PENDING';
export const SET_PRODUCT_CONFLICT = 'SET_PRODUCT_CONFLICT';
export const TOGGLE_PROD_CONFLICT = 'TOGGLE_PROD_CONFLICT';
export const SET_AUDIT_PENDING = 'SET_AUDIT_PENDING';
export const SET_REJECTED_PRODUCTS = 'SET_REJECTED_PRODUCTS';
export const SET_DELETION_PENDING = 'SET_DELETION_PENDING';
export const SET_BRAND_PROD_SELECTION = 'SET_BRAND_PROD_SELECTION';
export const SET_TAB_STATUS = 'SET_TAB_STATUS';
export const TOGGLE_ADD_PRODUCT_SLIDER = 'TOGGLE_ADD_PRODUCT_SLIDER';
export const TOGGLE_ADD_EDIT_BUTTON_ANIMATION = 'TOGGLE_ADD_EDIT_BUTTON_ANIMATION';
export const FROM_EDIT_PRODUCT_SLIDER = 'FROM_EDIT_PRODUCT_SLIDER';
export const TOGGLE_SEARCH_SLIDER = 'TOGGLE_SEARCH_SLIDER';
export const TOGGLE_ACTION_CARD_SLIDER = 'TOGGLE_ACTION_CARD_SLIDER';
export const TOGGLE_SUPPORT_SLIDER = 'TOGGLE_SUPPORT_SLIDER';
export const ACTION_CARD_FILTER = 'ACTION_CARD_FILTER';
export const RELOAD_ACTION_CARD_SLIDER = 'RELOAD_ACTION_CARD_SLIDER';
export const TOGGLE_TAB = 'TOGGLE_TAB';
export const TOGGLE_INFO_BOX = 'TOGGLE_INFO_BOX';
export const SET_OBJECTIONAL_PENDING = 'SET_OBJECTIONAL_PENDING';
export const SET_BRAND_PENDING = 'SET_BRAND_PENDING';
export const SET_GENERIC_DELETION_PENDING = 'SET_GENERIC_DELETION_PENDING';
export const SET_SELECTED_CATEGORY ='SET_SELECTED_CATEGORY';
export const SET_BRAND_SUGGESTION = 'SET_BRAND_SUGGESTION';
export const SET_QUEUE_TYPE = 'SET_QUEUE_TYPE';
export const SET_INITIAL_DATA = 'SET_INITIAL_DATA';
export const SET_HYBRID_DATA = 'SET_HYBRID_DATA';
export const SET_VIA_SUGGESTED = 'SET_VIA_SUGGESTED';
export const SET_SHOULD_RETAIN = 'SET_SHOULD_RETAIN';
export const SET_SUGGESTED_VIA_SEARCH = 'SET_SUGGESTED_VIA_SEARCH';
export const SHOW_HIDE_EDIT_OPTION = 'SHOW_HIDE_EDIT_OPTION';
export const UPDATE_DESC_TYPE = 'UPDATE_DESC_TYPE';
export const TOGGLE_AI_CREATION_MODAL = 'TOGGLE_AI_CREATION_MODAL';
//video upload actions
export const UPDATE_VIDEO_PROGRESS = 'UPDATE_VIDEO_PROGRESS';
export const UPDATE_PRODUCT_VIDEO = 'UPDATE_PRODUCT_VIDEO';
export const LINK_VIDEO_TO_PRODUCT = 'LINK_VIDEO_TO_PRODUCT';
export const UNLINK_VIDEO = 'UNLINK_VIDEO'
export const SET_VIDEO_LIBRARY_DATA = 'SET_VIDEO_LIBRARY_DATA';
export const TOGGLE_VIDEO_LIBRARY_SLIDER = 'TOGGLE_VIDEO_LIBRARY_SLIDER';
export const UPDATE_VIDEO_IN_LIBRARY = 'UPDATE_VIDEO_IN_LIBRARY';
export const UPDATE_VIDEO_ID_PRODUCT = 'UPDATE_VIDEO_ID_PRODUCT';
export const DELETE_VIDEO_LIBRARY = 'DELETE_VIDEO_LIBRARY';
export const TOGGLE_CONFIRM_DELETE = 'TOGGLE_CONFIRM_DELETE';
export const TOGGLE_CONFIRM_APPROVE = 'TOGGLE_CONFIRM_APPROVE';
export const UPDATE_BRAND_MANUFACTURE_DATA = 'UPDATE_BRAND_MANUFACTURE_DATA';
export const UPDATE_FIXED_SPECS = 'UPDATE_FIXED_SPECS';
export const ADD_VIDEO_TO_LIBRARY = 'ADD_VIDEO_TO_LIBRARY';
export const REMOVE_VIDEO_FROM_LIBRARY = 'REMOVE_VIDEO_FROM_LIBRARY';
export const DELETE_VIDEO_URL_ID_ALL_PRODUCTS = 'DELETE_VIDEO_URL_ID_ALL_PRODUCTS';
// export const


export const UPDATE_IMAGES_BEING_UPLOADED = 'UPDATE_IMAGES_BEING_UPLOADED';
export const RESET_LISTING_DATA = 'RESET_LISTING_DATA';
export const RESET_RESULT_DATA = 'RESET_RESULT_DATA';
export const TOGGLE_PRODUCT_VISIBILITY = 'TOGGLE_PRODUCT_VISIBILITY';
export const SET_PREVIOUS_TAB_INDEX = 'SET_PREVIOUS_TAB_INDEX';
export const LISTING_FILTER = 'LISTING_FILTER'
export const PENDING_TABS = 'PENDING_TABS'
export const PAUSE_APPROVAL_REDIRECT = 'PAUSE_APPROVAL_REDIRECT'
//edit brand category actions
export const RESET_CATEGORY_DATA = 'RESET_CATEGORY_DATA';
export const SET_CATEGORY_DATA = 'SET_CATEGORY_DATA';
export const SELECT_BRAND_CATEGORY_DATA = 'SELECT_BRAND_CATEGORY_DATA';
export const SELECT_SEARCH_BRAND_CAT = 'SELECT_SEARCH_BRAND_CAT';
export const SHOW_HIDE_LOADER = 'SHOW_HIDE_LOADER';
export const CLEAR_SEARCHED_ITEM = 'CLEAR_SEARCHED_ITEM';
export const SET_PRODUCT_SPECIFICATION = 'SET_PRODUCT_SPECIFICATION';
export const SET_ATTACHMENT_DATA = 'SET_ATTACHMENT_DATA';
export const DELETE_ATTACHMENT_FILE = 'DELETE_ATTACHMENT_FILE';
export const TOGGLE_EDIT_DISPLAYNAME_MODAL = 'TOGGLE_EDIT_DISPLAYNAME_MODAL';
export const RENAME_PRODUCT_ATTACHMENT = 'RENAME_PRODUCT_ATTACHMENT';
export const VIEW_FILE_DETAILS_SLIDER = 'VIEW_FILE_DETAILS_SLIDER';
export const TOGGLE_FILE_PROGRESS_BAR = 'TOGGLE_FILE_PROGRESS_BAR';
export const CANCEL_PENDING_FILES = 'CANCEL_PENDING_FILES';
export const MARK_PREVIOUSLY_UPLOADED_FILES = 'MARK_PREVIOUSLY_UPLOADED_FILES';
export const SET_AUDIT_OBJECT = 'SET_AUDIT_OBJECT';
export const SET_ATTACHMENT_DATA_VENDOR = 'SET_ATTACHMENT_DATA_VENDOR';
export const SET_MAPPING_OPTIONS = 'SET_MAPPING_OPTIONS';
export const UPDATE_BULK_DATA = 'UPDATE_BULK_DATA';
export const UPDATE_HEADER_MAPPING = 'UPDATE_HEADER_MAPPING';
export const SET_CURRENT_STEP = 'SET_CURRENT_STEP';
export const CLEAR_DATA = 'CLEAR_DATA';
export const FILE_ATTACHMENT_PERMISSION = 'FILE_ATTACHMENT_PERMISSION';
export const RESET_FILE_ATTACHMENT_DATA = 'RESET_FILE_ATTACHMENT_DATA';
export const SELECT_ALL_BRAND_CATEGORY_DATA = 'SELECT_ALL_BRAND_CATEGORY_DATA';
export const TOGGLE_PRODUCT_SERVICE = 'TOGGLE_PRODUCT_SERVICE';
export const SET_BROCHURE_DATA = 'SET_BROCHURE_DATA';
// end of edit brand category actions

//upload options
export const TOGGLE_UPLOAD_OPTIONS = 'TOGGLE_UPLOAD_OPTIONS';
export const TOGGLE_LINK_SLIDER = 'TOGGLE_LINK_SLIDER';
export const UPLOAD_YOUTUBE_VIDEO = 'UPLOAD_YOUTUBE_VIDEO';
export const UPLOAD_IMAGE_FROM_LINK = 'UPLOAD_IMAGE_FROM_LINK';
export const UPLOAD_MULTIPLE_IMAGES = 'UPLOAD_MULTIPLE_IMAGES';
export const TOGGLE_COPY_SLIDER = 'TOGGLE_COPY_SLIDER';
export const TOGGLE_SEARCH_IMAGE = 'TOGGLE_SEARCH_IMAGE';
//undo action types
export const RESTORE_PRODUCT_DATA = 'RESTORE_PRODUCT_DATA';
export const SET_DASHBOARD_DATA = 'SET_DASHBOARD_DATA';
//add edit item actions
export const UPDATE_ITEM_INFO = 'UPDATE_ITEM_INFO';
export const UPDATE_DISPLAY_INFO = 'UPDATE_DISPLAY_INFO';
export const UPDATE_CATEGORIES = 'UPDATE_CATEGORIES';
export const SET_ITEM_CATEGORY_DATA = 'SET_ITEM_CATEGORY_DATA';
export const SELECT_CATEGORY_DATA = 'SELECT_CATEGORY_DATA';
export const SET_ITEM_ERRORS = 'SET_ITEM_ERRORS';
export const SET_ITEM_WARNINGS = 'SET_ITEM_WARNINGS';
export const RESET_ITEM_ERRORS = 'RESET_ITEM_ERRORS';
export const PAINT_ITEM_DATA = 'PAINT_ITEM_DATA';
export const RESET_ITEM_INFO = 'RESET_ITEM_INFO';
//add edit image
export const UPDATE_ITEM_IMAGE = 'UPDATE_ITEM_IMAGE';
export const DELETE_ITEM_IMAGE = 'DELETE_ITEM_IMAGE';
export const RESTORE_ITEM_IMAGE = 'RESTORE_ITEM_IMAGE';
export const UPDATE_NEW_CATEGORY_IMAGE = 'UPDATE_NEW_CATEGORY_IMAGE';
export const DELETE_NEW_CATEGORY_IMAGE = 'DELETE_NEW_CATEGORY_IMAGE';
export const UPLOAD_IMAGE_FROM_ADD_EDIT = 'UPLOAD_IMAGE_FROM_ADD_EDIT';
export const DELETE_IMAGE_FROM_ADD_EDIT = 'DELETE_IMAGE_FROM_ADD_EDIT';
export const UPDATE_PRODUCT_VIDEO_FROM_ADD_EDIT = 'UPDATE_PRODUCT_VIDEO_FROM_ADD_EDIT';
export const REMOVE_VIDEO_FROM_ADD_EDIT = 'REMOVE_VIDEO_FROM_ADD_EDIT';
export const LINK_VIDEO_TO_PRODUCT_FROM_ADD_EDIT = 'LINK_VIDEO_TO_PRODUCT_FROM_ADD_EDIT';
export const UNLINK_VIDEO_TOP_RODUCT_FROM_ADD_EDIT = 'UNLINK_VIDEO_TO_PRODUCT_FROM_ADD_EDIT';
export const UPLOAD_YOUTUBE_VIDEO_FROM_ADD_EDIT = 'UPLOAD_YOUTUBE_VIDEO_FROM_ADD_EDIT';
//permissions
export const SET_ALL_PERMISSIONS = 'SET_ALL_PERMISSIONS';
export const SET_PACKAGE_PERMISSION_DATA = 'SET_PACKAGE_PERMISSION_DATA';
export const REDIRECTED_FROM = 'REDIRECTED_FROM';


//Contractors
export const SET_WELCOME_MODAL = 'SET_WELCOME_MODAL';
export const SET_CONTRACTOR_DATA = 'SET_CONTRACTOR_DATA';
export const SET_CONNECTED_NUMBER = 'SET_CONNECTED_NUMBER';
export const CHANGE_STATE = 'CHANGE_STATE';
export const SET_SEARCH_ARRAY = 'SET_SEARCH_ARRAY';

//Vendor Images
export const SET_VENDOR_IMAGES = 'SET_VENDOR_IMAGES'

//Vendor Objectionable Products
export const SET_VENDOR_OBJECTIONABLE_PRODUCTS = 'SET_VENDOR_OBJECTIONABLE_PRODUCTS'

//PhotoGallery
export const SET_SELECTED_GALLERY_IMAGES = 'SET_SELECTED_GALLERY_IMAGES';
export const TOGGLE_GALLERY_MODAL = 'TOGGLE_GALLERY_MODAL';
export const TOGGLE_PHOTO_SLIDER = 'TOGGLE_PHOTO_SLIDER';
export const SET_JD_PHOTOS_ADD_DATA = 'SET_JD_PHOTOS_ADD_DATA';

//Products Slider
export const SET_PRODUCT_SLIDER_DATA = 'SET_PRODUCT_SLIDER_DATA';

//Smart Fill Products
export const SET_SMART_FILL_DATA = 'SET_SMART_FILL_DATA';

//From Seller
export const SET_FROM_SELLER = 'SET_FROM_SELLER';

//Products Country
export const INITIAL_COUNTRY_CODE = 'INITIAL_COUNTRY_CODE';

//Auditor Update Log
export const SET_AUDITOR_BRANDED_LOG = 'SET_AUDITOR_BRANDED_LOG';
export const SET_SEARCH_BY_DOC_ID = 'SET_SEARCH_BY_DOC_ID';

//Specification
export const SET_INITIAL_SPECIFICATION_ATTRIBUTES = "SET_INITIAL_SPECIFICATION_ATTRIBUTES";
export const SAVE_SPECIFICATION_DATA = "SAVE_SPECIFICATION_DATA";
export const TOGGLE_SPECIFICATION_SLIDER = "TOGGLE_SPECIFICATION_SLIDER";
export const SAVE_CUSTOM_ATTRIBUTES = "SAVE_CUSTOM_ATTRIBUTES";
export const RESET_FORM_DATA = "RESET_FORM_DATA";
export const HANDLE_ON_INPUT_CHANGE = "HANDLE_ON_INPUT_CHANGE";
export const SET_ATTRIBUTE_IS_VALID = "SET_ATTRIBUTE_IS_VALID";
export const HANDLE_DROPDOWN_SELECT = "HANDLE_DROPDOWN_SELECT";
export const HANDLE_CHECKBOX_ON_CHANGE = "HANDLE_CHECKBOX_ON_CHANGE";
export const SET_ERROR_TO_ATTRIBUTE = "SET_ERROR_TO_ATTRIBUTE";
export const SET_ATTRIBUTE_LIST = "SET_ATTRIBUTE_LIST";
export const SAVE_CUSTOM_ATTRIBUTE_DATA = "SAVE_CUSTOM_ATTRIBUTE_DATA";
export const SHOW_FETCH_ERROR = "SHOW_FETCH_ERROR";
export const TOGGLE_DROPDOWN_DEPENDENT_CHILD = "TOGGLE_DROPDOWN_DEPENDENT_CHILD";
export const VALIDATION_UPDATE = "VALIDATION_UPDATE";
export const UPDATE_SPECIFICATION_DATA = "UPDATE_SPECIFICATION_DATA";
export const CONTENT_UNIT_HANDLE_CHANGE = "CONTENT_UNIT_HANDLE_CHANGE";
export const RESET_CONTENT_UNIT_DATA = "RESET_CONTENT_UNIT_DATA";
export const CONTENT_UNIT_RESET = "CONTENT_UNIT_RESET";

// for product Inventory
export const ALL_INVENTORY_PRODUCTS = 'ALL_INVENTORY_PRODUCTS';
export const LOW_INVENTORY_PRODUCTS = 'LOW_INVENTORY_PRODUCTS';
export const OUT_OF_STOCK_INVENTORY = 'OUT_OF_STOCK_INVENTORY_PRODUCTS';
export const INVENTORY_IS_FETCHING = 'IS_FETCHING_INVENTORY_PRODUCT';
export const INVENTORY_IS_FETCHED = 'IS_FETCHED_INVENTORY_PRODUCT';
export const INVENTORY_ERROR_FETCHING = 'ERROR_ON_FETCHING_INVENTORY_PRODUCT';
export const CHANGE_INVENTORY_TABS = 'CHANGE_PRODUCT_INVENTORY_TAB';
export const SHOW_PRODUCT_INVENTORY_VIEW = 'SHOW_PRODUCT_INVENTORY_BATCH_VIEW';
export const HIDE_PRODUCT_INVENTORY_VIEW = 'HIDE_PRODUCT_INVENTORY_BATCH_VIEW';
//Add Edit Discount
export const INITIAL_DISCOUNT_DATA = 'INITIAL_DISCOUNT_DATA';
export const CUSTOMER_LIST = 'CUSTOMER_LIST';

// variant
export const SHOW_VARIANT_TYPE_SLIDER = 'SHOW_VARIANT_TYPE_SLIDER';
export const SHOW_VARIANT_OPTIONS_SLIDER = 'SHOW_VARIANT_OPTIONS_SLIDER';
export const SHOW_EDIT_VARIANT_SLIDER = 'SHOW_EDIT_VARIANT_SLIDER';
export const SET_VARIANT_DATA = 'SET_VARIANT_DATA';
export const SHOW_VARIANT_DETAILS_SLIDER = 'SHOW_VARIANT_DETAILS_SLIDER';
export const SET_VARIANT_COMBINATIONS = 'SET_VARIANT_COMBINATIONS';
export const SET_VARIANT_PRODUCT_DATA = 'SET_VARIANT_PRODUCT_DATA';
export const SET_VARIANT_CORRECTION = 'SET_VARIANT_CORRECTION';
export const SHOW_MORE_DETAILS_SLIDER = 'SHOW_MORE_DETAILS_SLIDER';
export const RESET_VARIANT_DATA = 'RESET_VARIANT_DATA';
export const SET_SYNC_IMAGES = 'SET_SYNC_IMAGES';
export const SHOW_SYNC_IMAGES_MODAL = 'SHOW_SYNC_IMAGES_MODAL';
export const SHOW_SETTINGS_SLIDER = 'SHOW_SETTINGS_SLIDER';
export const SET_EDIT_VARIANT_DATA = 'SET_EDIT_VARIANT_DATA';
export const UPDATE_VARIANT_SPEC = 'UPDATE_VARIANT_SPEC';
//Order Return
export const SET_ORDER_RETURN_DATA = 'SET_ORDER_RETURN_DATA';
export const SET_TABS_COUNT = 'SET_TABS_COUNT';
export const UPDATE_SHIMMER = 'UPDATE_SHIMMER';
export const UPDATE_SELECTED_FILTER = 'UPDATE_SELECTED_FILTER';
export const REMOVE_SELECTED_FILTER = 'REMOVE_SELECTED_FILTER';
export const SET_ORDER_DETAILS_DATA = 'SET_ORDER_DETAILS_DATA';

//Order Claim
export const CHANGE_WEIGHT_DISPUTE_SLIDER = 'CHANGE_WEIGHT_DISPUTE_SLIDER';
export const SELECTED_ORDER = 'SELECTED_ORDER';
export const WEIGHT_DISPUTE_DATA = 'WEIGHT_DISPUTE_DATA';
export const CLEAR_WEIGHT_DATA = 'CLEAR_WEIGHT';
export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE';
export const SET_SEARCH_WEIGHT_DATA = 'SET_SEARCH_WEIGHT_DATA';
export const SET_SELECTED_FILTER = 'SET_SELECTED_FILTER';
export const SET_SEARCH_RETURN_DATA = 'SET_SEARCH_RETURN_DATA';
export const RESET_SEARCH_DATA = 'RESET_SEARCH_DATA';
export const VIEW_CLAIM_DATA = 'VIEW_CLAIM_DATA';

//Order Listing
export const SET_ORDER_LISTING_DATA = 'SET_ORDER_LISTING_DATA';
export const SET_LISTING_TABS_COUNT = 'SET_LISTING_TABS_COUNT';
export const UPDATE_CHECKED_LIST = 'UPDATE_CHECKED_LIST';
export const SET_SEARCH_LISTING_DATA = 'SET_SEARCH_LISTING_DATA';
export const RESET_SEARCH_LISTING_DATA = 'RESET_SEARCH_LISTING_DATA';
export const UPDATE_FILTER_LIST = 'UPDATE_FILTER_LIST';

//Barcode
export const TOGGLE_BARCODE_SCANNER = 'TOGGLE_BARCODE_SCANNER';
export const TOGGLE_BARCODE_SCANNER_SECONDARY = 'TOGGLE_BARCODE_SCANNER_SECONDARY';
export const TOGGLE_BARCODE_RESULTS = 'TOGGLE_BARCODE_RESULTS';
export const SET_SCANNER_RESULT = 'SET_SCANNER_RESULT';
export const SET_FAILED_STATUS = 'SET_FAILED_STATUS';
export const SET_BARCODE_DATA = 'SET_BARCODE_DATA';
export const RESET_BARCODE_DATA = 'RESET_BARCODE_DATA';

//Delivery Options
export const DELIVERY_OPTIONS_LIST = 'DELIVERY_OPTIONS_LIST';
export const DELIVERY_AGENTS_LIST = 'DELIVERY_AGENTS_LIST';
export const MULTIPLE_ORDERS_LIST = 'MULTIPLE_ORDERS_LIST';
export const ASSIGN_DELIVERY_BOY = 'ASSIGN_DELIVERY_BOY';
export const SET_REASSIGN_FLAG = 'SET_REASSIGN_FLAG';
export const SET_SINGLE_ITEM_DETAILS = 'SET_SINGLE_ITEM_DETAILS';

//DeliveryBoy
export const GET_DELIVERY_BOY_LIST = 'GET_DELIVERY_BOY_LIST';

//Category Cover
export const SET_JD_CAT_COVER_DATA = 'SET_JD_CAT_COVER_DATA';
export const SHOW_HIDE_JD_CAT_COVER = 'SHOW_HIDE_JD_CAT_COVER';

//Enrichment Audit Product
export const INIT_ENRICH_PRODUCT = 'INIT_ENRICH_PRODUCT';
export const SET_ENRICH_PRODUCTS = 'SET_ENRICH_PRODUCTS';
export const POST_ENRICH_PRODUCT = 'POST_ENRICH_PRODUCT';
export const SET_ENRICH_PRODUCT = 'SET_ENRICH_PRODUCT';
export const ENRICH_PRODUCT_SKIP = 'SET_ENRICH_PRODUCT_SKIP';

// BROCHURE
export const RESTORE_BROCHURE_ATH_FROM_LOCAL = 'RESTORE_BROCHURE_FROM_LOCAL';
export const TOGGLE_BROCHURE_UPLOADHISTORY_SLIDER = 'TOGGLE_BROCHURE_UPLOADHISTORY_SLIDER';
export const TOGGLE_BROCHURE_EDITNAME_DIALOG ='TOGGLE_BROCHURE_EDITNAME_DIALOG';
export const BROCHURE_UPLOAD_FILES_PROGRESS = 'BROCHURE_UPLOAD_FILES_PROGRESS';
export const TOGGLE_BROCHURE_FILE_PREVIEW = 'TOGGLE_BROCHURE_FILE_PREVIEW';
export const BROCHURE_SUCCESS_FILE_UPLOAD = 'BROCHURE_SUCCESS_FILE_UPLOAD';
export const BROCHURE_TOTAL_FILES_UPLOAD = 'BROCHURE_TOTAL_FILES_UPLOAD';
export const BROCHURE_TOTAL_FILES_ERROR = 'BROCHURE_TOTAL_FILES_ERROR';
export const BROCHURE_FILES_RESET_DATA = 'BROCHURE_FILES_RESET_DATA';
export const BROCHURE_TEMP_ACTIVE_TAB = 'BROCHURE_TEMP_TAB';
export const BROCHURE_LISTING_COUNT = 'BROCHURE_LISTING_COUNT';
export const BROCHURE_LISTING_DATA = 'BROCHURE_LISTING_DATA';

// PRODUCT CARD SLIDER
export const TOGGLE_PRODUCT_CARD_SLIDER = 'TOGGLE_PRODUCT_CARD_SLIDER';
export const PRICE_CARD_DATA_FETCHED = 'PRICE_CARD_DATA_FETCHED';

// Outdated product price
export const TOGGLE_OUTDATED_PRODUCT_CARD_SLIDER = 'TOGGLE_OUTDATED_PRODUCT_CARD_SLIDER';
export const OUTDATED_PRICE_CARD_DATA_FETCHED = 'OUTDATED_PRICE_CARD_DATA_FETCHED';
// IMAGE STATUS
export const IMAGE_UPLOAD_STATUS = 'IMAGE_UPLOAD_STATUS';

//Add Supplier
export const UPDATE_BUSINESS_DETAILS = 'UPDATE_BUSINESS_DETAILS';
export const UPDATE_CONTACT_DETAILS = 'UPDATE_CONTACT_DETAILS';
export const UPDATE_BILLING_ADDRESS = 'UPDATE_BILLING_ADDRESS';
export const UPDATE_TAX_DETAILS = 'UPDATE_TAX_DETAILS';
export const UPDATE_MISC_DATA = 'UPDATE_MISC_DATA';
export const UPDATE_ERROR_FIELDS = 'UPDATE_ERROR_FIELDS';
export const TOGGLE_REMOVE_MODAL = 'TOGGLE_REMOVE_MODAL';
export const TOGGLE_LOADING = 'TOGGLE_LOADING';

// category missing product
export const TOGGLE_CATEGORY_MISSING_CARD_SLIDER = 'TOGGLE_CATEGORY_MISSING_CARD_SLIDER';
export const CATEGORY_MISSING_DATA_FETCHED = 'CATEGORY_MISSING_DATA_FETCHED';
export const TOGGLE_CATEGORY_MISSING_CARD_SLIDER_PERSIST = 'TOGGLE_CATEGORY_MISSING_CARD_SLIDER_PERSIST';
